import { render, staticRenderFns } from "./certificateDataForm.vue?vue&type=template&id=e85721dc&"
import script from "./certificateDataForm.vue?vue&type=script&lang=js&"
export * from "./certificateDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports